interface Props {
  isOpen: boolean
  onClose: () => void
}

const ComingSoonModal = ({ isOpen, onClose }: Props) => {
  if (!isOpen) return null

  // No external open-login action here; this modal is informational only

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 10000 }}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '520px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <div className="modal-header" style={{ textAlign: 'center', width: '100%' }}>
          <h2 style={{ margin: 0, width: '100%', textAlign: 'center' }}>Panel Logowania</h2>
        </div>
        <div className="modal-body" style={{ textAlign: 'center', width: '100%' }}>
          <p style={{ margin: '0 auto', maxWidth: 440 }}>Funkcjonalność panelu logowania jest obecnie w fazie przygotowań</p>
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
            <button className="btn-primary" onClick={onClose} style={{ borderRadius: 0 }}>OK</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ComingSoonModal
